import { useTranslation } from "react-i18next";
import { ProductOrder } from "../../types/admin/productOrder.types";
import { ORDER_STATUS_STYLES } from "../../utils/statusButtonStyleSelectors";

export const ProductOrdersList = ({
  orders,
  setSearchParam,
}: {
  orders: ProductOrder[];
  setSearchParam: (params: Record<string, string>) => void;
}) => {
  const { t } = useTranslation();
  return (
    <div className="mt-10">
      <h2 className="text-lg font-semibold mb-4">{t("My Orders")}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {orders.length ? (
          orders.map((order) => {
            const statusStyle = ORDER_STATUS_STYLES[order.status];

            return (
              <div
                key={order._id}
                className="p-4 rounded-lg bg-primaryBg dark:bg-primaryBgDark cursor-pointer hover:shadow-md transition"
                onClick={() => setSearchParam({ orderId: order._id })}
              >
                <div className="flex justify-between items-start mb-3">
                  <span
                    className={`text-xs px-3 py-1 rounded-full font-medium ${statusStyle.className}`}
                  >
                    {statusStyle.label}
                  </span>
                </div>

                <p className="text-sm">
                  <span className="font-medium">
                    {t("Expected Delivery")}:{" "}
                  </span>
                  {order.expectedDelivery.split("T")[0]}
                </p>
                <p className="text-sm">
                  <span className="font-medium">{t("Price")}:</span> ₹
                  {order.price}
                </p>
              </div>
            );
          })
        ) : (
          <div className="text-primaryText dark:text-primaryTextDark col-span-1 md:col-span-2 text-center">
            {t("No orders found")}
          </div>
        )}
      </div>
    </div>
  );
};
